import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import get from 'lodash/get'
import pushGtmEvent from 'utils/gtm'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import { Row } from '@quotatisgroup/uikit-public.ui.row'

import { toast, Slide } from 'react-toastify'
import cloudinary from 'utils/cloudinary'
import config from 'config'

import 'react-toastify/dist/ReactToastify.css'

import CookiesBanner from 'components/CookiesBanner/CookiesBannerContainer'

import {
  Wrapper,
  Header,
  Content,
  Footer,
  NotificationBox,
  IconPart,
  TextPart,
  Title,
  Message,
  StyledToastContainer,
  StyledRotateImage,
} from './style'

const PageTemplateView = ({
  popin,
  locale,
  email,
  location: { pathname },
  header,
  children,
  footer,
  searchModalIsOpen,
  notifications,
  dispatchOpenNotifications,
  ...props
}) => {
  let currentUrl = null

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const setIntercomEvent = () => {
      const intercomAppId = get(config, `locales[${locale}].intercom.appId`)

      if (intercomAppId && email && pathname !== currentUrl) {
        pushGtmEvent({
          intercom_app_id: intercomAppId,
          intercom_user_email: email,
        })

        currentUrl = pathname
      }
    }

    setIntercomEvent()
    setLoaded(true)

    return () => {
      if (searchModalIsOpen) {
        toggleSearchModal(false)
      }
    }
  }, [locale, email, pathname, searchModalIsOpen])

  useEffect(() => {
    notifications.forEach(notification => {
      if (notification.opened === false) {
        const { id, title, message, status, autoClose } = notification
        const icon =
          status === 'error' ? 'close-circle-fill' : 'checkmark-circle-fill'

        const toastId = toast(
          <NotificationBox className="notifications">
            <IconPart>
              {status === 'loading' ? (
                <StyledRotateImage
                  class="spinner"
                  src={cloudinary(`/icons/spinner.svg`)}
                  size="xxs"
                  align="center"
                  alt="spinner"
                  sm="margin-md"
                />
              ) : (
                <Image
                  src={cloudinary(`/icons/${icon}.svg`)}
                  size="xxs"
                  align="center"
                  alt="spinner"
                  sm="margin-md"
                />
              )}
            </IconPart>
            <TextPart>
              {title && (
                <>
                  <Title>
                    <span>{title}</span>
                  </Title>
                  <br />
                </>
              )}
              <Message>
                <span>{message}</span>
              </Message>
            </TextPart>
          </NotificationBox>,
          {
            transition: Slide,
            autoClose: autoClose ? 5000 : false,
            toastId: id,
          },
        )

        dispatchOpenNotifications({ id, toastId })
      }
    })
  }, [notifications, dispatchOpenNotifications])

  return (
    <Wrapper {...props}>
      <CookiesBanner />
      {popin}
      <Header {...{ ...props, loaded }}>{header}</Header>
      <Row sm="margin-top-lg" />
      <Content>
        <StyledToastContainer
          className="toast-container"
          position="top-right"
          transition={Slide}
          hideProgressBar
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {children}
      </Content>
      <Footer>{footer}</Footer>
    </Wrapper>
  )
}

PageTemplateView.propTypes = {
  header: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
  footer: PropTypes.any.isRequired,
  searchModalIsOpen: PropTypes.bool,
  toggleSearchModal: PropTypes.func,
  nickname: PropTypes.string.isRequired,
  email: PropTypes.string,
  locale: PropTypes.string.isRequired,
  location: PropTypes.shape().isRequired,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      message: PropTypes.string,
    }),
  ),
  dispatchOpenNotifications: PropTypes.func.isRequired,
}

PageTemplateView.defaultProps = {
  searchModalIsOpen: false,
  toggleSearchModal: () => {},
  email: null,
  notifications: [],
}

export default withRouter(PageTemplateView)
